import React, { useState, useEffect } from 'react';
import styled from "@emotion/styled";
import OnSale from './OnSale';
import Sample from './Sample';
import SearchResults from './SearchResults';
import Featured from '../featured/Featured';
import OverlayComponent from '../shared/OverlayComponent';
import { Link } from 'react-router-dom';

const Layout = styled.div`
    margin-bottom: 10rem;
    display: flex;
    /* grid-auto-flow:row; */
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    /* height: calc(var(--footer-height)*4); */
    position:relative;
    width: inherit;

    .bg{
       position: absolute;
       transform: scale(1.7);
       display: flex;
       top: 21.15%;
       left: -16%;
    }
    .featured{
        height: 72rem;
        width:inherit;
        margin: 0 auto;
    }
    .featured > .cardGradient{
        position:absolute;
        right: 0rem;
        width: 2.9rem;
        height: 30.1rem;
        /* left: 1196px; */
        top: 500px;
        z-index:2;
        background: linear-gradient(270deg, #F3F5F7 90%, rgba(255, 255, 255, 0) 100%);
    }
    .featured > .cardGradient--second{
        position:absolute;
        width: 2.9rem;
        height: 30rem;
        left: -1.5rem;
        /* left: 1196px; */
        top: 31.25rem;
        z-index:2;
        background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    }
    @media only screen and (max-width: 1100px){
    
        
    }
    @media only screen and (max-width: 800px) {
       .featured{
           position:relative;
           display: flex;
       }
       .bg{
            top: 22%;
        }
    }
    @media only screen and (max-width: 500px) {
        .bg{
            top: 13%;
        }
        /* height: calc(var(--footer-height)*5); */
        
       
    }
    
`;
const ProductHeading = styled.div`
    position: relative;
    top: 8rem;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    .main-heading{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--space-40);
        line-height: 6rem;
        /* identical to box height, or 130% */


        /* Company Dark */

        color: #049CBE;
    }
    .sub-heading{
        width:40rem;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-20);
        line-height: var(--space-32);
        /* or 160% */


        /* default/gray/700 */

        color: #525B64;
    }
    &:before{
        content: url(/img/side_curves.svg);
        position:absolute;
        top: 5rem;
        right: -46rem;
    }
    &:after{
        content:url(/img/top_curves.svg);
        position:absolute;
        top: -13rem;
        right: 20rem;
    }
    div{
        position: absolute;
        width: 220rem;
        height: 80rem;
        left: -28rem;
        top: -10rem;
        z-index:-2;
        background: #F3F5F7;
    }
    .product_background{
        width:70rem;
        position:absolute;
        top:0.7rem;
        left:-30rem;
        z-index: inherit -1;
    }

    @media only screen and (max-width: 1100px){
        &:before{
            right: -24rem;
        }
        &:after{
            right: 10rem;
        }
    }
    @media only screen and (max-width: 800px){
  
        &:after{
            right: 5rem;
        }
    }
    @media only screen and (max-width: 425px) {
        margin-top: -6rem;
        .main-heading{
            font-size: var(--font-32);
        }
        .sub-heading{
            width: 22rem;
            font-size: var(--font-18);
            text-align: center;
        }
        &:before{
            content: none;
        }
        &:after{
            top: 4rem;
            right: -9rem;
        }
    }
`;

const BackgroundContainer = styled.div`
    background-color: rgb(243, 245, 247);
    width: inherit;
    height: 141vh;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url(/img/product_bg.png);
    background-repeat: no-repeat;
    background-size: 80rem;
    background-position-y: bottom;
    background-position-x: left;
    @media (max-width: 800px){
        background-position-x: -5rem;
    }
    @media (max-width: 500px){
        background-position-x: -10rem;
    }
`;
function ProductsLanding() {
    const [search, setSearch] = useState(true);
    const [display, setDisplay] = useState(false);
    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({
        product: '',
        media: ""
    });

    useEffect(() => window.scrollTo(0, 0));

    return (
        <>
            <OverlayComponent display={display} setDisplay={setDisplay} item={item} setItem={setItem} />
            <BackgroundContainer></BackgroundContainer>
            <Layout>

                <ProductHeading>
                    {/* <div></div> */}
                    {/* <img className="product_background" src="/img/product_bg.png"/> */}
                    <h1 className="main-heading">Our Products</h1>
                    <p className="sub-heading">Our comprehensive selection
                    is sure to meet all your medical supply needs,
                        complete with competitor comparisons.</p>
                </ProductHeading>
                {/* <div><img className="bg" src="/img/product_bg.png"/></div> */}
                <div className="featured">
                    {/* <div className="cardGradient"></div>   */}
                    {/* <div className="cardGradient--second"></div>   */}
                    <Featured value={search} search={setSearch} display={display} setDisplay={setDisplay} setItem={setItem} />
                </div>

                <Sample />

                <OnSale />
            </Layout>
        </>
    )
}

export default ProductsLanding;
